<span class="content" (click)="contentClick()" (keyup.enter)="contentClick()">
  <ng-content></ng-content>
</span>

<button *ngIf="dismissOnContentClick" mat-icon-button class="close-button" [attr.aria-label]="'Close' + bannerNotificationDescription" (click)="dismiss()">
  <mat-icon svgIcon="close"></mat-icon>
</button>
